<div (window:resize)="onResize()" id="divMatchlist">
  <p-table #table
           [value]="matches"
           [loading]="dataLoading?.isLoading || loading"

           selectionMode="single"

           rowGroupMode="subheader"
           [groupRowsBy]="groupRowsBy"

           [rowHover]="true"
           [class]="tableClass + ' p-datatable-sm'"

           [sortOrder]="1"

           responsiveLayout="scroll"
           [scrollable]="scrollable"
           [scrollHeight]="scrollable ? 'flex' : ''"
           [style]="scrollable ? {'height': (tableHeight + 'px')} : {}"

           [stripedRows]="groupRowsBy !== 'matchReportBlock.blockIndex'"

           [showGridlines]="true">

    <!-- [class.tableBottomGrid]="groupRowsBy === 'matchReportBlock.blockIndex'" -->

    <!--
    [scrollHeight]="scrollable ? (tableHeight + 'px') : ''"

    [sortMode]="sortEnabled ? undefined : 'custom'"
    [sortField]="'datePlanned'" -->

    <ng-template pTemplate="header">
      <tr>
        @if (showColumnEvent) {
          <th style='width: 120px;' class="invisible-cell-phone pt-2 pb-2 text-center">
            {{'EVENT' | translate}}
          </th>
        }
        @if (showGameNr && !sortEnabled) {
          <th [style]="'width: ' + (isMobile ? '20' : '30') + 'px;'" class="pt-2 pb-2 text-center">
            #
          </th>
        }
        @if (showGameNr && sortEnabled) {
          <th [style]="'width: ' + (isMobile ? '20' : '30') + 'px;'" class="pt-2 pb-2 text-center"
              pSortableColumn="gameNr">
            #
          </th>
        }
        @if (showBoardIntern) {
          <th style='width: 30px;' class="text-center">
            @if (fontWhite) {
              <img ngSrc="../../../../../../../assets/img/icons/frontend/board_white.svg"
                   height="20" width="20" style="margin-top: -2px; margin-bottom: -2px;"
                   [pTooltip]="(isEDart ? 'MACHINE' : 'BOARD') | translate"/>
            } @else {
              <img ngSrc="../../../../../../../assets/img/icons/frontend/board_black.svg"
                   height="20" width="20" style="margin-top: -2px; margin-bottom: -2px;"
                   [pTooltip]="(isEDart ? 'MACHINE' : 'BOARD') | translate"/>
            }
          </th>
        }
        @if (showDate && showDateIntern && !sortEnabled) {
          <th [style]="'width: ' + (isMobile ? '50' : '150') + 'px;'" class="text-center">
            {{'DATE' | translate}}
          </th>
        }
        @if (showDate && showDateIntern && sortEnabled) {
          <th [style]="'width: ' + (isMobile ? '50' : '150') + 'px;'" class="text-center" pSortableColumn="datePlanned">
            {{'DATE' | translate}}
            <p-sortIcon field="datePlanned" class="sorticon"></p-sortIcon>
          </th>
        }

        @if (rowView) {
          @if (isKratzer) {
            <th class="text-center">{{tableHeaderMatches | translate}}</th>
          } @else {
            <th class="text-center">
              {{tableHeaderMatches | translate}}
            </th>
          }
        } @else {
          @if (showTime) {
            <th style='width: 50px;' class="invisible-cell-phone pt-2 pb-2 text-center">
              {{'TIME' | translate}}
            </th>
          }
          @if (showWriter) {
            <th style='width: 50px;' class="visible-cell-phone text-center">
              @if (fontWhite) {
                <img ngSrc="/assets/img/icons/frontend/writer_white.svg"
                     height="20" width="20" style="margin-top: -2px; margin-bottom: -2px;"
                     [pTooltip]="'WRITER' | translate"/>
              } @else {
                <img ngSrc="/assets/img/icons/frontend/writer_black.svg"
                     height="20" width="20" style="margin-top: -2px; margin-bottom: -2px;"
                     [pTooltip]="'WRITER' | translate"/>
              }
            </th>
          }

          @if (isKratzer) {
            <th class="text-center">{{tableHeaderMatches | translate}}</th>
          } @else {
            <th class="text-center" colspan="3">
              {{tableHeaderMatches | translate}}
            </th>
          }
          @if (showWriter) {
            <th class="invisible-cell-phone" style="max-width: 300px;">{{'WRITER' | translate}}</th>
          }
          @if (showColumnRound && !sortEnabled) {
            <th class="invisible-cell-phone" style="max-width: 180px;">
              {{'ROUND' | translate}}
            </th>
          }
          @if (showColumnRound && sortEnabled) {
            <th class="invisible-cell-phone" style="max-width: 180px;"
                pSortableColumn="round.name">
              {{'ROUND' | translate}}
              <p-sortIcon field="round.name" class="sorticon"></p-sortIcon>
            </th>
          }
        }
        <th [style]="'width: ' + (isMobile ? '20' : '40') + 'px;'">
        </th>
      </tr>

    </ng-template>

    <ng-template pTemplate="groupheader" let-match>
      @if (grouping && match.active) {

        @if (groupRowsBy === 'matchReportBlock.blockIndex' && match.matchReportBlock?.showGroupHeader) {
          <tr pRowGroupHeader class="group-header-blue">
            <td colspan="8">
              <div class="flex w-full align-items-center">
                <div class="flex-1 font-bold">
                  {{ ('GROUP_BLOCK_X' | translate: {value: match.matchReportBlock.group}) }}
                </div>
              </div>
            </td>
          </tr>
        }

        <tr pRowGroupHeader [class]="(groupRowsBy === 'blockIndex' ? 'group-header-accent-white ' : 'group-header ') + (groupRowsBy === 'round.id' ? match.round.styleClass : '')">
          @if (groupRowsBy === 'matchReportBlock.blockIndex') {
            <td colspan="8">
              <div class="flex w-full align-items-center">
                <div class="flex-1 font-bold">
                  {{match.matchReportBlock?.displayName}}
                </div>
                @if (match.matchReportBlock?.matchmode) {
                  <div>
                    {{match.matchReportBlock.matchmode | setlegmodePipe: 'total': false}}
                  </div>
                }
              </div>
            </td>
          } @else if (groupRowsBy === 'blockIndex') {
            <td colspan="8">
              <div class="flex w-full align-items-center">
                <div class="flex-1 font-bold">
                  @if (match.playingVenue?.name) {
                    {{match.playingVenue?.name}}
                  } @else {
                    {{match.blockIndex}}
                  }
                </div>
              </div>
            </td>
          } @else {
            <td colspan="8">
              <div class="flex w-full align-items-center">
                @if (groupRowsBy === 'round.id') {
                  <div>
                    <span>
                      <span class="font-bold">
                        {{match.round.name}}
                      </span>
                      @if (isLeague && match.round.dateFrom) {
                        <span class="pl-1">
                          ({{match.round.dateFrom | roundDatePipe: match.round.dateTo}})
                        </span>
                      }
                      @if (!isLeague && match.round.matchmode && !isTeam) {
                        <span class="pl-1">
                          ({{match.round.matchmode | setlegmodePipe: 'total': false}})
                        </span>
                      }
                    </span>
                  </div>
                }
                @if (groupRowsBy === 'event.name') {
                  <div>
                    {{match.event.name}}
                  </div>
                }
                <div class="flex-1"></div>
              </div>
            </td>
          }
        </tr>

        <!-- Sieht besser aus, bei unterschiedlichen Hintergrundfarben -->
        <tr class="hidden"><td>&nbsp;</td></tr>
      }
    </ng-template>

    <ng-template pTemplate="body" let-match let-rowIndex="rowIndex">
      @if (match.active) {
        <tr [@successTrigger]="match.currentState" (@successTrigger.done)="match.currentState = 'initial'"
            [class.match-running]="match.statusCd === 'ACTIVE'"
            [class.flip]="match.highlightOut"
            [class.animation-duration-500]="match.highlightOut"
            [class.animation-fill-forwards]="match.highlight"
            [class.animation-duration-1000]="match.highlight"
            [class.animation-color]="match.highlight"
            [class.tableBottomGrid]="groupRowsBy === 'matchReportBlock.blockIndex'"

            (click)="matchSelected(match, null)">

          @if (showColumnEvent) {
            <td class="invisible-cell-phone">
              <div class="underline cursor-pointer" (click)="eventClicked($event, match.event)">
                {{ match.event?.name }}
              </div>
            </td>
          }
          @if (showGameNr) {
            <td [style]="'width: ' + (isMobile ? '20' : '30') + 'px;'" class="text-center">
              {{match.gameNr}}
            </td>
          }
          @if (showBoardIntern) {
            <td style='width: 30px;' class="text-center text-bluegray-200"
                [class.padding-small]="isMobile">
              @if (match.board) {
                <p-badge [styleClass]="'p-badge-board p-badge-accent white-space-nowrap flex align-items-center'"
                         [value]="match.board"
                         [pTooltip]="('BOARD' | translate) + ' ' + match.board"
                         [showDelay]="400" tooltipPosition="bottom"/>
              }
            </td>
          }
          @if (showDate && showDateIntern) {
            <td style='width: 50px;' class="text-center" [class.padding-small]="isMobile">
              <app-date-time-presenter [date]="match.datePlanned" [small]="true" [match]="match"
                                       [oneRow]="displayView || !isMobile"
                                       [dateTimeFormat]="isMobile ? 'dd.MM.yy HH:mm' : 'desktop'"
                                       [dateFormat]="isMobile ? 'dd.MM.yy' : 'desktop'" />
            </td>
          }

          @if (rowView) {
            <!-- Mobile Ansicht -->
            <td>
              <div>
                @if ((showTime && (match.endDate || match.datePlanned)) ||
                     showColumnEvent ||
                     showColumnRound ||
                     (showWriter && match.active && (match.statusCd === DOMAIN_VALUE_STATUS_MATCH_OPEN || match.statusCd === DOMAIN_VALUE_STATUS_MATCH_PAUSE)))
                {
                  <div class="flex align-items-center gap-2 text-gray-400 pb-1">
                    @if (showTime && (match.endDate || match.datePlanned)) {
                      <div class="divider-item flex align-items-center gap-1">
                        <i class="pi pi-clock text-xxs line-height-unset"></i>
                        <span>
                          {{(match.endDate || match.datePlanned) | date: 'HH:mm'}}
                        </span>
                      </div>
                    }
                    @if (showColumnEvent) {
                      <div class="divider-item flex align-items-center gap-1 underline cursor-pointer"
                           (click)="eventClicked($event, match.event)">
                        {{match.event?.name}}
                      </div>
                    }
                    @if (showColumnRound) {
                      <div class="divider-item">{{match.round.name}}</div>
                    }
                    @if (showWriter && match.active && (match.statusCd === DOMAIN_VALUE_STATUS_MATCH_OPEN || match.statusCd === DOMAIN_VALUE_STATUS_MATCH_PAUSE)) {
                      <div class="divider-item frontend-text-gray flex align-items-center gap-1">
                        <ng-container [ngTemplateOutlet]="templateWriterLogo" [ngTemplateOutletContext]="{size: 14}"/>
                        <span>{{match.writer | participantPipe: null: null: null: null}}</span>
                      </div>
                    }
                  </div>
                }

                @if (isKratzer) {
                  <div class="flex flex-wrap" [id]="'divMatchId#' + match.id">
                    @for (mp of match.participants; track mp) {
                      <div class="pr-2">
                        <app-kratzer-teilnehmer [match]="match" [matchParticipant]="mp" [editable]="false"/>
                      </div>
                    }
                  </div>
                } @else {
                  @if (isLeague && match.matchReport && (match.byeHome || match.byeAway)) {
                    <div class="text-center py-1 text-gray-500">
                      {{'NO_MATCH' | translate}}:&nbsp;
                      {{(match.byeHome ? match.participantGuest : match.participantHome) | participantPipe: undefined: undefined: undefined: event}}
                    </div>
                  } @else {
                    <div class="match-row-mobile">
                      <ng-container [ngTemplateOutlet]="templateParticipantHome"
                                    [ngTemplateOutletContext]="{match: match}"/>
                      <ng-container [ngTemplateOutlet]="templateResult" [ngTemplateOutletContext]="{match: match, home: true}"/>
                      <ng-container [ngTemplateOutlet]="templateParticipantGuest"
                                    [ngTemplateOutletContext]="{match: match}"/>
                      <ng-container [ngTemplateOutlet]="templateResult" [ngTemplateOutletContext]="{match: match, home: false}"/>
                    </div>
                    <!--<div class="flex gap-2 min-w-0">
                      <div class="flex-1 flex flex-column gap-1 pr-2">
                        <ng-container [ngTemplateOutlet]="templateParticipantHome"
                                      [ngTemplateOutletContext]="{match: match}"/>
                        <ng-container [ngTemplateOutlet]="templateParticipantGuest"
                                      [ngTemplateOutletContext]="{match: match}"/>
                      </div>
                      <div class="flex flex-column gap-1">
                        <ng-container [ngTemplateOutlet]="templateResult" [ngTemplateOutletContext]="{match: match, home: true}"/>
                        <ng-container [ngTemplateOutlet]="templateResult" [ngTemplateOutletContext]="{match: match, home: false}"/>
                      </div>
                    </div>-->
                  }
                }
              </div>

                <!--@if (showWriter && match.active) {
                  <div class="frontend-text-gray flex align-items-center gap-2">
                    <ng-container [ngTemplateOutlet]="templateWriterLogo" [ngTemplateOutletContext]="{size: 14}"/>
                    <span>{{match.writer | participantPipe: null: null: null}}</span>
                  </div>
                }-->
            </td>
          } @else {
            <!-- Tablet/Desktop Ansicht -->
            @if (showTime) {
              <td [style]="'width: ' + (isMobile ? '50' : '80') + 'px;'" class="invisible-cell-phone text-center">
                @if (match.endDate) {
                  {{match.endDate | date: 'HH:mm'}}
                } @else if (match.datePlanned) {
                  {{match.datePlanned | date: 'HH:mm'}}
                }
              </td>
            }
            @if (showWriter) {
              <td style='width: 50px;' class="visible-cell-phone text-bluegray-200">
                {{match.writer | participantShortPipe: matches}}
              </td>
            }

            @if (isKratzer) {
              <td>
                <div class="flex flex-wrap" [id]="'divMatchId#' + match.id">
                  @for (mp of match.participants; track mp) {
                    <div class="pr-2">
                      <app-kratzer-teilnehmer [match]="match" [matchParticipant]="mp" [editable]="false"/>
                    </div>
                  }
                </div>
              </td>
            } @else {
              <td [colSpan]="3" [class.padding-small]="isMobile && !isLeague">
                @if (isMobile && (showColumnRound || showColumnEvent)) {
                  <div class="flex align-items-center justify-content-center text-bluegray-200 text-center pb-1">
                    @if (showColumnEvent) {
                      <div class="underline cursor-pointer" (click)="eventClicked($event, match.event)">
                        {{match.event?.name}}
                      </div>
                      @if (showColumnRound) {
                        -
                      }
                    }
                    @if (showColumnRound) {
                      {{match.round.name}}
                    }
                    @if (showTime && (match.endDate || match.datePlanned)) {
                      <span>
                        ({{(match.endDate ?? match.datePlanned) | date: 'HH:mm'}})
                      </span>
                    }
                  </div>
                }

                @if (isLeague && match.matchReport && (match.byeHome || match.byeAway)) {
                  <div class="text-center py-1 text-gray-500">
                    {{'NO_MATCH' | translate}}:&nbsp;
                    {{(match.byeHome ? match.participantGuest : match.participantHome) | participantPipe: undefined: undefined: undefined: event}}
                  </div>
                } @else {
                  <div class="flex">
                    <ng-container [ngTemplateOutlet]="templateParticipantHome" [ngTemplateOutletContext]="{match: match}"/>
                    <div class="text-center pl-2 pr-2 min-width-result">
                      @if (!match.refresh) {
                        <span [class.text-orange]="match.statusCd === 'ACTIVE'"
                              [class.font-italic]="match.statusCd === 'ACTIVE'"
                              [pTooltip]="isMobile ? (match | matchResultPipe: undefined: false: false: undefined: true) : ''"
                              [showDelay]="400">
                          {{match | matchResultPipe: undefined: isMobile: true: undefined: true}}
                        </span>
                      }
                    </div>
                    <ng-container [ngTemplateOutlet]="templateParticipantGuest" [ngTemplateOutletContext]="{match: match}"/>
                  </div>
                }
              </td>
            }

            @if (showWriter) {
              <td class="invisible-cell-phone text-bluegray-200">
                @if (match.active) {
                  <span>
                    {{match.writer | participantPipe: null: null: null: null}}
                  </span>
                }
              </td>
            }

            @if (showColumnRound) {
              <td class="invisible-cell-phone" style="width: 180px;">
                <div class="cell-nowrap" [pTooltip]="match.round.name" [showDelay]="400">
                  {{match.round.name}}
                </div>
              </td>
            }
          }

          <td [style]="'width: ' + (isMobile ? '20' : '40') + 'px;'" class="padding-w-small">
            <div class="flex"
                 [class.justify-content-end]="!rowView" [class.justify-content-center]="rowView"
                 [class.flex-column]="rowView" [class.gap-1]="rowView">
              <ng-container [ngTemplateOutlet]="templateButtons" [ngTemplateOutletContext]="{data: match}"/>
            </div>
          </td>
        </tr>
      }
    </ng-template>

  </p-table>
</div>

<ng-template #templateParticipantHome let-match="match" pTemplate="match">
  <div [id]="'divMatchId#' + match.id"
       class="flex-1 player-highlight flex align-items-center gap-1"
       [class.flex-row-reverse]="!rowView"
       [class.text-right]="!rowView"
       [class.team]="rowView"
       [class.text-gray-600]="!match.participantHome"
       [class.text-green]="matchResultService.isWinnerHome(match)"
       [pTooltip]="match.tooltipHome" [showDelay]="400">
    @if (match.active) {
      <span [class]="'participant_' + match.participantHome?.id"
            [class.cursor-pointer]="showMouseOver"
            [class.line-through]="match.participantHome?.retired"
            [class.team-span]="rowView"
            (mouseover)="mouseOver(match.participantHome?.id)" (mouseout)="mouseOut(match.participantHome?.id)">
        {{match.participantHome | participantPipe: true: match: matches: match.event}}
      </span>
      <ng-container [ngTemplateOutlet]="avgTemplate"
                    [ngTemplateOutletContext]="{data: match.participantHome}"/>
    }
  </div>
</ng-template>
<ng-template #templateParticipantGuest let-match="match" pTemplate="match">
  <div class="flex-1 player-highlight flex align-items-center gap-1"
       [class.align-items-center]="rowView"
       [class.team]="rowView"
       [class.text-gray-600]="!match.participantGuest"
       [class.text-green]="matchResultService.isWinnerAway(match)"
       [pTooltip]="match.tooltipAway" [showDelay]="400" tooltipPosition="left">
    @if (match.active) {
      <span [class]="'participant_' + match.participantGuest?.id"
            [class.cursor-pointer]="showMouseOver"
            [class.line-through]="match.participantGuest?.retired"
            [class.team-span]="rowView"
            (mouseover)="mouseOver(match.participantGuest?.id)"
            (mouseout)="mouseOut(match.participantGuest?.id)">
        {{match.participantGuest | participantPipe: false: match: matches: match.event}}
      </span>
      <ng-container [ngTemplateOutlet]="avgTemplate"
                    [ngTemplateOutletContext]="{data: match.participantGuest}"/>
    }
  </div>
</ng-template>

<ng-template #templateResult let-match="match" let-home="home" pTemplate="match">
  <div class="flex justify-content-center align-items-center">
    @if (!match.refresh) {
      <span class="cell-nowrap"
            [class.text-orange]="match.statusCd === 'ACTIVE'"
            [class.font-italic]="match.statusCd === 'ACTIVE'"
            [class.px-1]="match.statusCd === 'ACTIVE'"
            [pTooltip]="isMobile ? (match | matchResultPipe: (home ? 1 : 2): false: false: undefined: true) : ''"
            [showDelay]="400">
        {{match | matchResultPipe: (home ? 1 : 2): isMobile: true: undefined: false}}
      </span>
    }
  </div>
</ng-template>

<ng-template #templateButtons let-match="data" pTemplate="match">
  @if (match.hasPerformances) {
    <p-button icon="pi pi-flag"
              styleClass="p-button-rounded p-button-text p-button-success"
              [style]="{'margin-top': '-10px', 'margin-bottom': '-10px'}"
              tooltipPosition="left"
              [pTooltip]="'BEST_PERFORMANCES' | translate"
              (click)="onPerformancesClicked($event, match)"/>
  }
  @if (match.isDartsscorer && match.statusCd === 'FINISH') {
    <p-button styleClass="p-button-rounded p-button-text p-button-success" icon="pi pi-chart-bar"
              [style]="{'margin-top': '-10px', 'margin-bottom': '-10px'}"
              tooltipPosition="left"
              [pTooltip]="'STATISTICS' | translate" (click)="onStatisticsClicked($event, match)"/>
  }
  @if (match.differentMatchMode) {
    <span class="pi pi-info-circle" [pTooltip]="'DIFFERENT_MATCH_MODE' | translate"></span>
  }
</ng-template>

<ng-template #templateWriterLogo let-size="size">
  @if (fontWhite) {
    <img ngSrc="/assets/img/icons/frontend/writer_white.svg"
         [height]="size" [width]="size" style="margin-top: -2px; margin-bottom: -2px;"
         [pTooltip]="'WRITER' | translate"/>
  } @else {
    <img ngSrc="/assets/img/icons/frontend/writer_black.svg"
         [height]="size" [width]="size" style="margin-top: -2px; margin-bottom: -2px;"
         [pTooltip]="'WRITER' | translate"/>
  }
</ng-template>

<ng-template #avgTemplate let-item="data" pTemplate="item">
  @if (item?.darts > 0 && item?.score > 0) {
    <span>({{item.score | averagePipe: item.darts: false}})</span>
  }
</ng-template>
